module.exports = __webpack_public_path__ + "img/marron-2.cad2138d.png";